import { OTHER_TOPICS_TOPIC } from '@/queries/constants'

import { ENRICHMENT_WORLD_SLUG } from '../worlds'

export function shouldAskForQualificationsWhenHostingSeries({ worldSlug }: { worldSlug: string }) {
  return worldSlug === ENRICHMENT_WORLD_SLUG
}

export function shouldAskForQualificationsWhenHostingSession({ topicName }: { topicName: string }) {
  return topicName === OTHER_TOPICS_TOPIC
}
